import React from "react";
import { FiLock } from "react-icons/fi";
import { useNoctisReachabilityPolled } from "../../hooks/useIntegrationStatus";

const buildTitle = ({ checking, enabled, reachable, authorized, httpStatus, latencyMs, error }) => {
  const titleParts = [];
  if (checking) titleParts.push("Noctis check bezig…");
  else if (error) titleParts.push("Noctis status fout");
  else if (enabled === false) titleParts.push("Noctis niet ingeschakeld/geconfigureerd");
  else if (reachable === true && authorized !== false) titleParts.push("Noctis werkt");
  else if (reachable === true && authorized === false) titleParts.push("Noctis auth faalt");
  else if (reachable === false) titleParts.push("Noctis niet bereikbaar");
  else titleParts.push("Noctis status onbekend");
  if (httpStatus != null) titleParts.push(`HTTP ${httpStatus}`);
  if (latencyMs != null) titleParts.push(`${latencyMs}ms`);
  return titleParts.join(" • ");
};

export default function NoctisStatusDot({ showLabel = true } = {}) {
  const snapshot = useNoctisReachabilityPolled(true);
  const reachability = snapshot?.data ?? null;
  const loading = Boolean(snapshot?.loading);
  const error = snapshot?.error ?? null;
  const enabled = reachability?.enabled ?? reachability?.configured ?? null;
  const reachable = reachability?.reachable;
  const authorized = reachability?.authorized;
  const httpStatus = reachability?.httpStatus ?? reachability?.http_status ?? snapshot?.meta?.httpStatus ?? null;
  const latencyMs = reachability?.latencyMs ?? reachability?.latency_ms ?? snapshot?.meta?.latencyMs ?? null;

  const checking = loading || reachability == null || reachable == null || authorized == null;
  const title = buildTitle({ checking, enabled, reachable, authorized, httpStatus, latencyMs, error });

  const dotClass =
    checking
      ? "bg-amber-500 shadow-[0_0_0_4px_rgba(245,158,11,0.18)]"
      : enabled === false
        ? "bg-rose-500 shadow-[0_0_0_4px_rgba(244,63,94,0.18)]"
        : reachable === true && authorized !== false
          ? "bg-emerald-500 shadow-[0_0_0_4px_rgba(16,185,129,0.18)]"
          : "bg-rose-500 shadow-[0_0_0_4px_rgba(244,63,94,0.18)]";

  return (
    <div className="flex items-center gap-2" title={title} aria-label={title}>
      <span className={`h-3 w-3 rounded-full ${dotClass}`} />
      {showLabel && (
        <span className="inline-flex items-center gap-1 text-sm font-semibold text-gray-600 dark:text-gray-300">
          Noctis
          {!checking && reachable === true && authorized === false && (
            <FiLock className="text-rose-600 dark:text-rose-300" aria-label="Auth failure" />
          )}
        </span>
      )}
    </div>
  );
}
